import { render, staticRenderFns } from "./IconText.vue?vue&type=template&id=431f602b&scoped=true&"
import script from "./IconText.vue?vue&type=script&lang=js&"
export * from "./IconText.vue?vue&type=script&lang=js&"
import style0 from "./IconText.vue?vue&type=style&index=0&id=431f602b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431f602b",
  null
  
)

export default component.exports